import { ComponentBase, gh, getProps, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { Diagram } from '@syncfusion/ej2-diagrams';
import { LayersDirective, LayerDirective, LayersPlugin, LayerPlugin } from './layers.directive';
import { CustomCursorsDirective, CustomCursorDirective, CustomCursorsPlugin, CustomCursorPlugin } from './customcursor.directive';
import { ConnectorFixedUserHandlesDirective, ConnectorFixedUserHandleDirective, ConnectorFixedUserHandlesPlugin, ConnectorFixedUserHandlePlugin } from './connector-fixeduserhandle.directive';
import { ConnectorAnnotationsDirective, ConnectorAnnotationDirective, ConnectorAnnotationsPlugin, ConnectorAnnotationPlugin } from './connector-annotation.directive';
import { ConnectorsDirective, ConnectorDirective, ConnectorsPlugin, ConnectorPlugin } from './connectors.directive';
import { NodeFixedUserHandlesDirective, NodeFixedUserHandleDirective, NodeFixedUserHandlesPlugin, NodeFixedUserHandlePlugin } from './node-fixeduserhandle.directive';
import { NodeAnnotationsDirective, NodeAnnotationDirective, NodeAnnotationsPlugin, NodeAnnotationPlugin } from './node-annotation.directive';
import { PortsDirective, PortDirective, PortsPlugin, PortPlugin } from './ports.directive';
import { NodesDirective, NodeDirective, NodesPlugin, NodePlugin } from './nodes.directive';
export const properties = ['isLazyUpdate', 'plugins', 'addInfo', 'annotationTemplate', 'backgroundColor', 'bridgeDirection', 'commandManager', 'connectorDefaults', 'connectors', 'constraints', 'contextMenuSettings', 'customCursor', 'dataSourceSettings', 'diagramSettings', 'drawingObject', 'enableConnectorSplit', 'enablePersistence', 'enableRtl', 'fixedUserHandleTemplate', 'getConnectorDefaults', 'getCustomCursor', 'getCustomProperty', 'getCustomTool', 'getDescription', 'getNodeDefaults', 'height', 'historyManager', 'layers', 'layout', 'locale', 'mode', 'model', 'nodeDefaults', 'nodeTemplate', 'nodes', 'pageSettings', 'rulerSettings', 'scrollSettings', 'segmentThumbShape', 'segmentThumbSize', 'selectedItems', 'serializationSettings', 'setNodeTemplate', 'snapSettings', 'tool', 'tooltip', 'updateSelection', 'userHandleTemplate', 'width', 'animationComplete', 'click', 'collectionChange', 'commandExecute', 'connectionChange', 'contextMenuBeforeItemRender', 'contextMenuClick', 'contextMenuOpen', 'created', 'dataLoaded', 'doubleClick', 'dragEnter', 'dragLeave', 'dragOver', 'drop', 'elementDraw', 'expandStateChange', 'fixedUserHandleClick', 'historyChange', 'historyStateChange', 'keyDown', 'keyUp', 'layoutUpdated', 'load', 'loaded', 'mouseEnter', 'mouseLeave', 'mouseOver', 'mouseWheel', 'onFixedUserHandleMouseDown', 'onFixedUserHandleMouseEnter', 'onFixedUserHandleMouseLeave', 'onFixedUserHandleMouseUp', 'onImageLoad', 'onUserHandleMouseDown', 'onUserHandleMouseEnter', 'onUserHandleMouseLeave', 'onUserHandleMouseUp', 'positionChange', 'propertyChange', 'rotateChange', 'scrollChange', 'segmentChange', 'segmentCollectionChange', 'selectionChange', 'sizeChange', 'sourcePointChange', 'targetPointChange', 'textEdit'];
export const modelProps = [];
export const testProp = getProps({ props: properties });
export const props = testProp[0], watch = testProp[1], emitProbs = Object.keys(watch);
emitProbs.push('modelchanged', 'update:modelValue');
for (let props of modelProps) {
    emitProbs.push('update:' + props);
}
/**
 * Represents vue Diagram Component
 * ```html
 * <ejs-diagram></ejs-diagram>
 * ```
 */
export let DiagramComponent = vueDefineComponent({
    name: 'DiagramComponent',
    mixins: [ComponentBase],
    props: props,
    watch: watch,
    emits: emitProbs,
    provide() { return { custom: this.custom }; },
    data() {
        return {
            ej2Instance: new Diagram({}),
            propKeys: properties,
            models: modelProps,
            hasChildDirective: true,
            hasInjectedModules: true,
            tagMapper: { "e-layers": "e-layer", "e-cursormaps": "e-cursormap", "e-connectors": { "e-connector": { "e-connector-fixeduserhandles": "e-connector-fixeduserhandle", "e-connector-annotations": "e-connector-annotation" } }, "e-nodes": { "e-node": { "e-node-fixeduserhandles": "e-node-fixeduserhandle", "e-node-annotations": "e-node-annotation", "e-node-ports": "e-node-port" } } },
            tagNameMapper: { "e-cursormaps": "e-customCursor", "e-connector-fixeduserhandles": "e-fixedUserHandles", "e-connector-annotations": "e-annotations", "e-node-fixeduserhandles": "e-fixedUserHandles", "e-node-annotations": "e-annotations", "e-node-ports": "e-ports" },
            isVue3: !isExecute,
            templateCollection: {},
        };
    },
    created() {
        this.bindProperties();
        this.ej2Instances._setProperties = this.ej2Instances.setProperties;
        this.ej2Instances.setProperties = this.setProperties;
        this.ej2Instances.clearTemplate = this.clearTemplate;
        this.updated = this.updated;
    },
    render(createElement) {
        let h = !isExecute ? gh : createElement;
        let slots = null;
        if (!isNullOrUndefined(this.$slots.default)) {
            slots = !isExecute ? this.$slots.default() : this.$slots.default;
        }
        return h('div', slots);
    },
    methods: {
        clearTemplate(templateNames) {
            if (!templateNames) {
                templateNames = Object.keys(this.templateCollection || {});
            }
            if (templateNames.length && this.templateCollection) {
                for (let tempName of templateNames) {
                    let elementCollection = this.templateCollection[tempName];
                    if (elementCollection && elementCollection.length) {
                        for (let ele of elementCollection) {
                            this.destroyPortals(ele);
                        }
                        delete this.templateCollection[tempName];
                    }
                }
            }
        },
        setProperties(prop, muteOnChange) {
            if (this.isVue3) {
                this.models = !this.models ? this.ej2Instances.referModels : this.models;
            }
            if (this.ej2Instances && this.ej2Instances._setProperties) {
                this.ej2Instances._setProperties(prop, muteOnChange);
            }
            if (prop && this.models && this.models.length) {
                Object.keys(prop).map((key) => {
                    this.models.map((model) => {
                        if ((key === model) && !(/datasource/i.test(key))) {
                            if (this.isVue3) {
                                this.ej2Instances.vueInstance.$emit('update:' + key, prop[key]);
                            }
                            else {
                                this.$emit('update:' + key, prop[key]);
                                this.$emit('modelchanged', prop[key]);
                            }
                        }
                    });
                });
            }
        },
        custom() {
            this.updated();
        },
        add(obj, group) {
            return this.ej2Instances.add(obj, group);
        },
        addChildToGroup(group, child) {
            return this.ej2Instances.addChildToGroup(group, child);
        },
        addChildToUmlNode(node, child, umlChildType) {
            return this.ej2Instances.addChildToUmlNode(node, child, umlChildType);
        },
        addConnector(obj) {
            return this.ej2Instances.addConnector(obj);
        },
        addConnectorLabels(obj, labels) {
            return this.ej2Instances.addConnectorLabels(obj, labels);
        },
        addConstraints(constraintsType, constraintsValue) {
            return this.ej2Instances.addConstraints(constraintsType, constraintsValue);
        },
        addCustomHistoryEntry(entry) {
            return this.ej2Instances.addCustomHistoryEntry(entry);
        },
        addElements(obj) {
            return this.ej2Instances.addElements(obj);
        },
        addHistoryEntry(entry, sourceId) {
            return this.ej2Instances.addHistoryEntry(entry, sourceId);
        },
        addLabels(obj, labels) {
            return this.ej2Instances.addLabels(obj, labels);
        },
        addLanes(node, lane, index) {
            return this.ej2Instances.addLanes(node, lane, index);
        },
        addLayer(layer, layerObject) {
            return this.ej2Instances.addLayer(layer, layerObject);
        },
        addNode(obj, group) {
            return this.ej2Instances.addNode(obj, group);
        },
        addNodeLabels(obj, labels) {
            return this.ej2Instances.addNodeLabels(obj, labels);
        },
        addNodeToLane(node, swimLane, lane) {
            return this.ej2Instances.addNodeToLane(node, swimLane, lane);
        },
        addPhases(node, phases) {
            return this.ej2Instances.addPhases(node, phases);
        },
        addPorts(obj, ports) {
            return this.ej2Instances.addPorts(obj, ports);
        },
        addProcess(process, parentId) {
            return this.ej2Instances.addProcess(process, parentId);
        },
        addTextAnnotation(annotation, node) {
            return this.ej2Instances.addTextAnnotation(annotation, node);
        },
        align(option, objects, type) {
            return this.ej2Instances.align(option, objects, type);
        },
        bringIntoView(bound) {
            return this.ej2Instances.bringIntoView(bound);
        },
        bringLayerForward(layerName) {
            return this.ej2Instances.bringLayerForward(layerName);
        },
        bringToCenter(bound) {
            return this.ej2Instances.bringToCenter(bound);
        },
        bringToFront() {
            return this.ej2Instances.bringToFront();
        },
        clear() {
            return this.ej2Instances.clear();
        },
        clearHistory() {
            return this.ej2Instances.clearHistory();
        },
        clearSelection() {
            return this.ej2Instances.clearSelection();
        },
        cloneLayer(layerName) {
            return this.ej2Instances.cloneLayer(layerName);
        },
        copy() {
            return this.ej2Instances.copy();
        },
        cut() {
            return this.ej2Instances.cut();
        },
        destroy() {
            return this.ej2Instances.destroy();
        },
        distribute(option, objects) {
            return this.ej2Instances.distribute(option, objects);
        },
        distributePorts(nodeIds) {
            return this.ej2Instances.distributePorts(nodeIds);
        },
        doLayout() {
            return this.ej2Instances.doLayout();
        },
        drag(obj, tx, ty) {
            return this.ej2Instances.drag(obj, tx, ty);
        },
        dragSourceEnd(obj, tx, ty) {
            return this.ej2Instances.dragSourceEnd(obj, tx, ty);
        },
        dragTargetEnd(obj, tx, ty) {
            return this.ej2Instances.dragTargetEnd(obj, tx, ty);
        },
        editSegment(editOptions) {
            return this.ej2Instances.editSegment(editOptions);
        },
        endGroupAction() {
            return this.ej2Instances.endGroupAction();
        },
        exportDiagram(options) {
            return this.ej2Instances.exportDiagram(options);
        },
        exportImage(image, options) {
            return this.ej2Instances.exportImage(image, options);
        },
        findElementUnderMouse(obj, position, diagram, padding) {
            return this.ej2Instances.findElementUnderMouse(obj, position, diagram, padding);
        },
        findObjectUnderMouse(objects, action, inAction) {
            return this.ej2Instances.findObjectUnderMouse(objects, action, inAction);
        },
        findObjectsUnderMouse(position, source) {
            return this.ej2Instances.findObjectsUnderMouse(position, source);
        },
        findTargetObjectUnderMouse(objects, action, inAction, position, source) {
            return this.ej2Instances.findTargetObjectUnderMouse(objects, action, inAction, position, source);
        },
        fitToPage(options) {
            return this.ej2Instances.fitToPage(options);
        },
        getActiveLayer() {
            return this.ej2Instances.getActiveLayer();
        },
        getConnectorObject(id) {
            return this.ej2Instances.getConnectorObject(id);
        },
        getCursor(action, active) {
            return this.ej2Instances.getCursor(action, active);
        },
        getDiagramAction(diagramAction) {
            return this.ej2Instances.getDiagramAction(diagramAction);
        },
        getDiagramBounds() {
            return this.ej2Instances.getDiagramBounds();
        },
        getDiagramContent(styleSheets) {
            return this.ej2Instances.getDiagramContent(styleSheets);
        },
        getEdges(args) {
            return this.ej2Instances.getEdges(args);
        },
        getHistoryStack(isUndoStack) {
            return this.ej2Instances.getHistoryStack(isUndoStack);
        },
        getNodeObject(id) {
            return this.ej2Instances.getNodeObject(id);
        },
        getObject(name) {
            return this.ej2Instances.getObject(name);
        },
        getParentId(id) {
            return this.ej2Instances.getParentId(id);
        },
        getTool(action) {
            return this.ej2Instances.getTool(action);
        },
        group() {
            return this.ej2Instances.group();
        },
        hideTooltip(obj) {
            return this.ej2Instances.hideTooltip(obj);
        },
        insertData(node) {
            return this.ej2Instances.insertData(node);
        },
        loadDiagram(data, isEJ1Data) {
            return this.ej2Instances.loadDiagram(data, isEJ1Data);
        },
        loadDiagramFromMermaid(data) {
            return this.ej2Instances.loadDiagramFromMermaid(data);
        },
        moveForward() {
            return this.ej2Instances.moveForward();
        },
        moveObjects(objects, targetLayer) {
            return this.ej2Instances.moveObjects(objects, targetLayer);
        },
        moveObjectsUp(node, currentLayer) {
            return this.ej2Instances.moveObjectsUp(node, currentLayer);
        },
        nudge(direction, x, y, type) {
            return this.ej2Instances.nudge(direction, x, y, type);
        },
        pan(horizontalOffset, verticalOffset, focusedPoint, isInteractiveZoomPan) {
            return this.ej2Instances.pan(horizontalOffset, verticalOffset, focusedPoint, isInteractiveZoomPan);
        },
        paste(obj) {
            return this.ej2Instances.paste(obj);
        },
        print(options) {
            return this.ej2Instances.print(options);
        },
        printImage(image, options) {
            return this.ej2Instances.printImage(image, options);
        },
        redo() {
            return this.ej2Instances.redo();
        },
        remove(obj) {
            return this.ej2Instances.remove(obj);
        },
        removeChildFromGroup(group, child) {
            return this.ej2Instances.removeChildFromGroup(group, child);
        },
        removeConstraints(constraintsType, constraintsValue) {
            return this.ej2Instances.removeConstraints(constraintsType, constraintsValue);
        },
        removeData(node) {
            return this.ej2Instances.removeData(node);
        },
        removeLabels(obj, labels) {
            return this.ej2Instances.removeLabels(obj, labels);
        },
        removeLane(node, lane) {
            return this.ej2Instances.removeLane(node, lane);
        },
        removeLayer(layerId) {
            return this.ej2Instances.removeLayer(layerId);
        },
        removePhase(node, phase) {
            return this.ej2Instances.removePhase(node, phase);
        },
        removePorts(obj, ports) {
            return this.ej2Instances.removePorts(obj, ports);
        },
        removeProcess(id) {
            return this.ej2Instances.removeProcess(id);
        },
        reset() {
            return this.ej2Instances.reset();
        },
        resetSegments() {
            return this.ej2Instances.resetSegments();
        },
        rotate(obj, angle, pivot, rotateUsingHandle) {
            return this.ej2Instances.rotate(obj, angle, pivot, rotateUsingHandle);
        },
        sameSize(option, objects) {
            return this.ej2Instances.sameSize(option, objects);
        },
        saveDiagram() {
            return this.ej2Instances.saveDiagram();
        },
        saveDiagramAsMermaid() {
            return this.ej2Instances.saveDiagramAsMermaid();
        },
        scale(obj, sx, sy, pivot) {
            return this.ej2Instances.scale(obj, sx, sy, pivot);
        },
        select(objects, multipleSelection, oldValue) {
            return this.ej2Instances.select(objects, multipleSelection, oldValue);
        },
        selectAll() {
            return this.ej2Instances.selectAll();
        },
        sendBackward() {
            return this.ej2Instances.sendBackward();
        },
        sendLayerBackward(layerName) {
            return this.ej2Instances.sendLayerBackward(layerName);
        },
        sendToBack() {
            return this.ej2Instances.sendToBack();
        },
        setActiveLayer(layerName) {
            return this.ej2Instances.setActiveLayer(layerName);
        },
        setStackLimit(stackLimit) {
            return this.ej2Instances.setStackLimit(stackLimit);
        },
        showTooltip(obj) {
            return this.ej2Instances.showTooltip(obj);
        },
        startGroupAction() {
            return this.ej2Instances.startGroupAction();
        },
        startTextEdit(node, id) {
            return this.ej2Instances.startTextEdit(node, id);
        },
        unGroup() {
            return this.ej2Instances.unGroup();
        },
        unSelect(obj) {
            return this.ej2Instances.unSelect(obj);
        },
        undo() {
            return this.ej2Instances.undo();
        },
        updateData(node) {
            return this.ej2Instances.updateData(node);
        },
        updateFromModel() {
            return this.ej2Instances.updateFromModel();
        },
        updateViewPort() {
            return this.ej2Instances.updateViewPort();
        },
        zoom(factor, focusedPoint) {
            return this.ej2Instances.zoom(factor, focusedPoint);
        },
        zoomTo(options) {
            return this.ej2Instances.zoomTo(options);
        },
    }
});
export const DiagramPlugin = {
    name: 'ejs-diagram',
    install(Vue) {
        Vue.component(DiagramPlugin.name, DiagramComponent);
        Vue.component(LayerPlugin.name, LayerDirective);
        Vue.component(LayersPlugin.name, LayersDirective);
        Vue.component(CustomCursorPlugin.name, CustomCursorDirective);
        Vue.component(CustomCursorsPlugin.name, CustomCursorsDirective);
        Vue.component(ConnectorPlugin.name, ConnectorDirective);
        Vue.component(ConnectorsPlugin.name, ConnectorsDirective);
        Vue.component(ConnectorFixedUserHandlePlugin.name, ConnectorFixedUserHandleDirective);
        Vue.component(ConnectorFixedUserHandlesPlugin.name, ConnectorFixedUserHandlesDirective);
        Vue.component(ConnectorAnnotationPlugin.name, ConnectorAnnotationDirective);
        Vue.component(ConnectorAnnotationsPlugin.name, ConnectorAnnotationsDirective);
        Vue.component(NodePlugin.name, NodeDirective);
        Vue.component(NodesPlugin.name, NodesDirective);
        Vue.component(NodeFixedUserHandlePlugin.name, NodeFixedUserHandleDirective);
        Vue.component(NodeFixedUserHandlesPlugin.name, NodeFixedUserHandlesDirective);
        Vue.component(NodeAnnotationPlugin.name, NodeAnnotationDirective);
        Vue.component(NodeAnnotationsPlugin.name, NodeAnnotationsDirective);
        Vue.component(PortPlugin.name, PortDirective);
        Vue.component(PortsPlugin.name, PortsDirective);
    }
};
